import { render, staticRenderFns } from "./MobileInput.vue?vue&type=template&id=1d974c4a&scoped=true&"
import script from "./MobileInput.vue?vue&type=script&lang=js&"
export * from "./MobileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d974c4a",
  null
  
)

export default component.exports